export default function viewOn(parentScope) {
  const _on = new On(parentScope)
  return _on
}


/** WEBPACK FOOTER **
 ** ./client/lib/viewOn.js
 **/